import React from 'react'
import PropTypes from 'prop-types'
import TextWithRowsColsField from './TextWithRowsColsField'

const RadioDoubleField = ({ baseName, label }) => {
  return <TextWithRowsColsField baseName={baseName} label={label} />
}

export default RadioDoubleField

RadioDoubleField.propTypes = {
  baseName: PropTypes.string,
  label: PropTypes.string
}
